import styled from 'styled-components';

export const DivTableNovedades = styled.div.attrs({
  className: 'overflow-y-auto',
})`
  height: 8rem;
`;
